/* eslint-disable */
import { Actions, ActionsTypes } from '../actions/actions';

export interface State {
  isLoading: boolean;
  ssoLinks: any;
}

function getInitialState(): State {
  return {
    isLoading: true,
    ssoLinks: []
  };
}

const initialState: State = getInitialState();

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionsTypes.InitSsoLinks: {
      return { ...getInitialState(), isLoading: true };
    }

    case ActionsTypes.SetSsoLinks: {
      return { ...state, isLoading: false, ssoLinks: action.payload.ssoLinks };
    }

    default:
      return state;
  }
}
